<template>
  <v-card flat class="glossary">
  <v-subheader class="subheader">Network Usage
    </v-subheader>
    <v-card>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr class="headings">
          <th width="25%" class="text-left">Data Type</th>
          <th width="60%" class="text-left">Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in networkUsage" :key="item.type">
          <td class="pt-5 pb-5 pr-5">{{item.type}}</td>
          <td class="pt-5 pb-5 pr-5">{{item.description}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>
    <v-subheader class="subheader mt-5">Managed Devices
    </v-subheader>
    <v-card>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr class="headings">
          <th width="15%" class="text-left">Data Field Name</th>
          <th width="34%" class="text-left">Description</th>
          <th width="17%" class="text-center">Available for Windows Devices?</th>
          <th width="18%" class="text-center">Available for Chrome Devices?</th>
          <th width="18%" class="text-center">Available for Apple Devices? </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in fieldItems" :key="item.name">
          <td class="pt-5 pb-5 pr-5">{{item.name}}</td>
          <td class="pt-5 pb-5 pr-5"><span v-html="item.description"></span></td>
          <td class="pt-5 pb-5 pr-5 text-center">
            <span v-if="item.statusWindows === 'TBC'">TBC</span>
            <span class="available" v-if="item.statusWindows === 'Y'">
              <v-icon>check_circle</v-icon>
            </span>
            <span class="unavailable" v-if="item.statusWindows === 'N'">
              <v-icon>cancel</v-icon>
            </span>
          </td>
          <td class="pt-5 pb-5 pr-5 text-center">
            <span v-if="item.statusChrome === 'TBC'">TBC</span>
            <span class="available"  v-if="item.statusChrome === 'Y'">
              <v-icon>check_circle</v-icon>
            </span>
            <span class="unavailable" v-if="item.statusChrome === 'N'">
              <v-icon>cancel</v-icon>
            </span>
          </td>
          <td class="pt-5 pb-5 pr-5 text-center">
            <span v-if="item.statusApple === 'TBC'">TBC</span>
            <span class="available" v-if="item.statusApple === 'Y'">
              <v-icon>check_circle</v-icon>
            </span>
            <span class="unavailable" v-if="item.statusApple === 'N'">
              <v-icon>cancel</v-icon>
            </span>
            </td></tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-card>
  </v-card>
</template>

<script>
  export default {
    name: 'GLOSSARY',
    data(){

      return { fieldItems: [
        {
          name:"B/L/R Location",
          description:`The Building / Level / Room location of the device is manually defined at a school level from within UDM (for Windows devices only).
Can be used to physically identify where the device is stored.`,
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"N"
          },
          {
          name:"Build Number",
          description:`Displays the Build / version number.
Chrome Devices show the “Major version” only.
Can assist with understanding if a device needs updating.

The “Top 10 Build Number” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
              name:"CPU Spec",
              description:`Processor make/model and specification speed. Helps to determine the capability of the machine. Not available for Apple non-computer devices. `,
              statusWindows:"Y",
              statusChrome:"Y",
              statusApple:"Y"
          },
          {
          name:"Device Name",
          description:`Name of the device, defined at Build / Rebuild.

          For MS Devices, it is the MAC Address plus “P” (for Production issued device).
Chrome is the serial number.
Apple is the general device name.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Form Factor",
          description:`The shape/design of the machine. Choices are: Desktop, Chrome Book, Laptop, Tablet, Server, VM, Other (may include whiteboards etc), Unknown (if the device does not provide this information).
Helps to identify the actual machine based on its shape.

The “Form Factor” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Last Offline",
          description:`The date/time the device was last logged out of.
Helps determine when a device was finished being used.

The “Last Seen” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"N"
          },
          {
          name:"Last Online",
          description:`The date the device was last identified as being connected to the network.
Helps to understand how long ago it was accessed.`,
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"Y"
          },
          {
          name:"Local Disk",
          description:`Displays in Gigabytes (Gb) the size of the "C Drive" for Microsoft & Chrome Devices and "/" (Root) for Apple Devices, which is the boot drive. Helps to understand a device’s capability.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Manufacturer",
          description:`The name of the company that produced the device and the specified model (where possible).
Helps in physically identifying the device.`,
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"Y"
          },
          {
          name:"Memory (RAM)",
          description:`The total amount of RAM that a device has.
Can help in determining the capability of a device and if it’s fit for purpose.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Model",
          description:`The specific model name / type / number where provided by the manufacturer.
Helps in physically identifying the device.

The “Top 10 Model” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Model Release Date",
          description:'The approximate year the specific model came into service as defined in eT4L or by the manufacturer. <b>In most cases</b>, the day and month of the <b>release</b> date are defaulted to 01/01 as the full date is not readily available in the data source, <b>only the year.</b> The Model Release Date can be used to help determine the aging devices in the fleet. The “Age of Model” chart in the Managed Devices page is'+

            'based on the data in this column, please keep in mind that "Age of Model" is an approximation due to the date/month limitation mentioned above.',
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"N"
          },
          {
          name:"Operating System",
          description:`The OS installed on the device.
Helps determine the type of device.

The “Operating System” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"School Code",
          description:`Each school has a unique site code, however some dual-sited infant and public schools may share one.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },
          {
          name:"Serial Number",
          description:`The unique number assigned to the device upon build.
Helps in physically identifying the device.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"Y"
          },

          {
          name:"UDM Role",
          description:`Role helps understand who the device is most likely used by.

This can be set within UDM or on F12 rebuild. Choices includes: Student, Staff, Admin, Corporate, Kiosk etc.
Can assist during Equipment Roll-out phases.`,
          statusWindows:"Y",
          statusChrome:"N",
          statusApple:"N"
          },
          {
          name:"Warranty Expires",
          description:`The date / year that the device’s warranty is due to (or has) expired.
Helps to determine if the manufacturer would be willing to repair if problems exist.

The “Warranty” chart in the Managed Devices page is based on the data in this column.`,
          statusWindows:"Y",
          statusChrome:"Y",
          statusApple:"N"
          }
      ],
    internetUsage:[
      {
        type:"Number of hits",
        description:"A hit is a request to a web server for a file (such as a web page, image, JavaScript, or Cascading Style Sheet). There may be many hits per single page view since an HTML page can contain multiple files, such as images."
      },
      {
        type:"Inbound and Outbound",
        description:"This means that these charts show traffic going out from and coming into the school. Outbound traffic occurs when the DoE server sends data to another server or client.Inbound traffic occurs when other servers sends data back to the DoE server."
      },
      {
        type:"Department and Non-Department",
        description:"Department data examples include most DoE applications such as SAP and Student Management. Non-Department data refers general internet browsing such as YouTube and Google."
      }
    ],
    networkUsage:[
      {
        type:"WAN Utilisation",
        description:"The WAN (Wide Area Network) is your school’s link to the Department network that gives you internet access. Both Department and non-Department data flows through this link."
      },
      {
        type:"Internet@Edge Utilisation",
        description:"Schools with Internet@Edge have an additional link only for non-Department traffic such as YouTube, leaving the WAN link for only Department traffic such as DoE apps."
      },
      {
        type:"Bandwidth cap",
        description:"This is the limit of the amount of data which users can download or upload via their connection."
      }
    ]
    }
    }
  };

</script>
<style scoped>
::v-deep .available .theme--light.v-icon{
  color:#00A908 !important;
  font-size:20px;
}
::v-deep .unavailable .theme--light.v-icon{
  color:#B81237 !important;
  font-size:20px;
}
.headings th{
  font-family: Arial;
font-style: normal;
font-weight: bold;
font-size: 14px !important;
line-height: 17px;
color: #121212 !important;
padding:20px;
}
.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
      background: transparent !important;
  }
.subheader{
font-family: Arial;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 30px;
color: #041E42;
padding:24px 0 40px 0;
}
.glossary{
  padding:0;
  background: #FFFFFF;

}
</style>
